export default __webpack_public_path__ + "static/media/6.a3b46492.png";